import { defineStore } from 'pinia'

export const user = defineStore('user', {
    state: () => {
        return {
            userInfo: JSON.parse(localStorage.getItem("userInfo") || '{}'),
        }
    },
    actions: {
        setUserInfo(obj) {
            console.log(obj)
            this.userInfo = obj;
            localStorage.setItem("userInfo", JSON.stringify(obj));
        },
    }
})